/**
 * Created by Josef Jurca on 8.3.2017.
 */

import {ActionTypes} from '../actions/asset';

/**
 * Returns the asset state.
 *
 * @param {Object} state - Current state.
 * @param {Object} action - Action object.
 * @returns {Object} State.
 */
export default function asset (state = {}, action) {

    switch (action.type) {

        case ActionTypes.SET_ASSET:
            return Object.assign({}, state, action.asset);
            
        default:
            return state;
    }

}


// WEBPACK FOOTER //
// ./src/js/store/reducers/asset.js